import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/react-query';
import { useAuthStore } from '@/store/useAuthStore';

interface AuthProviderProps {
    children: ReactNode;
}

export default function AuthProvider({ children }: AuthProviderProps) {
    const { initialize } = useAuthStore();

    useEffect(() => {
        // Initialize auth state on app startup
        initialize();
    }, [initialize]);

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
